import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AddressToStringPipe } from './address-to-string.pipe';
import { GoogleMapsImagePipe } from './google-maps-image.pipe';

@NgModule({
  declarations: [AddressToStringPipe, GoogleMapsImagePipe],
  providers: [AddressToStringPipe, GoogleMapsImagePipe],
  exports: [AddressToStringPipe, GoogleMapsImagePipe],
  imports: [CommonModule],
})
export class LocationModule {}
